/**
 * Ícones da home da plataforma, em SVG inline.
 *
 * O resto do app usa Font Awesome via CDN (index.html). Aqui não: a home é
 * pública, então o CSS do CDN passaria a bloquear o primeiro paint de todo
 * visitante anônimo e viraria um ponto único de falha da landing. São poucos
 * ícones e todos ficam acima da dobra.
 */

import React from 'react';

type IconProps = {
  className?: string;
};

const base = 'shrink-0';

export const PlayIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={`${base} ${className}`}>
    <path d="M8 5.14v13.72a1 1 0 0 0 1.54.84l10.78-6.86a1 1 0 0 0 0-1.68L9.54 4.3A1 1 0 0 0 8 5.14Z" />
  </svg>
);

export const PlaySquareIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    aria-hidden="true" className={`${base} ${className}`}>
    <rect x="3" y="4" width="18" height="16" rx="3" />
    <path d="M11 9.5v5l4-2.5-4-2.5Z" fill="currentColor" stroke="none" />
  </svg>
);

export const InfoIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" aria-hidden="true" className={`${base} ${className}`}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" />
    <path d="M12 7.75h.01" />
  </svg>
);

export const UsersIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${base} ${className}`}>
    <path d="M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19" />
    <circle cx="10" cy="8" r="3.2" />
    <path d="M20 19v-1.5a3.5 3.5 0 0 0-2.6-3.38" />
    <path d="M15.6 5.2a3.2 3.2 0 0 1 0 5.6" />
  </svg>
);

export const GearIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${base} ${className}`}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 2.5v2.2M12 19.3v2.2M21.5 12h-2.2M4.7 12H2.5M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6M18.7 18.7l-1.6-1.6M6.9 6.9 5.3 5.3" />
  </svg>
);

export const MenuIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" aria-hidden="true" className={`${base} ${className}`}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const ChevronLeftIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${base} ${className}`}>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

export const ChevronRightIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${base} ${className}`}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export const LockIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`${base} ${className}`}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
  </svg>
);

export const SpinnerIcon: React.FC<IconProps> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"
    className={`${base} animate-spin ${className}`}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.25" />
    <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);
